module.exports = __webpack_public_path__ + "img/P2051593.c7801352.jpg";